export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Team',
  },
  {
    anchor: 'about',
    alias: '#about',
    title: 'About',
  },
  {
    anchor: 'projects',
    alias: '#projects',
    title: 'Projects',
  },
];
